import { Link } from "react-router-dom";

const CookieSection = ({ number, title, children }) => (
  <section aria-labelledby={`cookies-section-${number}`} className="border-t border-[#0E1B31]/10 pt-9 sm:pt-11">
    <h2 id={`cookies-section-${number}`} className="font-display text-2xl sm:text-3xl font-semibold leading-snug text-[#0E1B31]">
      {number}. {title}
    </h2>
    <div className="mt-5 space-y-4 text-[15px] sm:text-base leading-[1.8] text-[#3B4A5E]">{children}</div>
  </section>
);

const LegalLink = ({ to, children }) => (
  <Link className="underline underline-offset-4 hover:text-[#0E1B31]" to={to}>{children}</Link>
);

export default function CookiePolicy() {
  return (
    <div data-testid="cookie-policy-page">
      <header className="relative overflow-hidden mesh-hero grain pt-36 pb-16 lg:pt-44 lg:pb-20">
        <div className="perspective-grid" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-mono-brand text-[11px] tracking-[0.28em] uppercase text-[#2C4A6F]">ΠΟΛΙΤΙΚΗ COOKIES</p>
          <h1 className="mt-7 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.06] text-[#0E1B31]">Πολιτική Cookies</h1>
          <p className="mt-6 text-sm sm:text-base text-[#3B4A5E]">Τελευταία ενημέρωση: 27 Οκτωβρίου 2026</p>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-20 lg:py-24 space-y-11 sm:space-y-14" aria-label="Πολιτική Cookies CRESTIA">
        <div className="space-y-5 text-[15px] sm:text-base leading-[1.8] text-[#3B4A5E]">
          <p>Η παρούσα Πολιτική Cookies εξηγεί με απλό τρόπο πώς μπορεί να χρησιμοποιούνται cookies και παρόμοιες τεχνολογίες στον ιστότοπο της CRESTIA.</p>
        </div>

        <CookieSection number="1" title="Τι είναι τα cookies">
          <p>Τα cookies είναι μικρά αρχεία που μπορεί να αποθηκεύονται στη συσκευή σας όταν επισκέπτεστε έναν ιστότοπο. Παρόμοιες τεχνολογίες επιτρέπουν την αποθήκευση πληροφοριών στο πρόγραμμα περιήγησης για τη λειτουργία του ιστοτόπου ή άλλους συγκεκριμένους σκοπούς.</p>
        </CookieSection>

        <CookieSection number="2" title="Χρήση τεχνολογιών">
          <p>Η CRESTIA μπορεί να χρησιμοποιεί τεχνολογίες που είναι απολύτως απαραίτητες για τη λειτουργία του ιστοτόπου. Προαιρετικές τεχνολογίες μπορεί να χρησιμοποιούνται μόνο όταν ενεργοποιούνται πράγματι.</p>
          <p>Ο ιστότοπος χρησιμοποιεί μόνο τις τεχνολογίες που είναι απαραίτητες για τη λειτουργία του ή όσες ενεργοποιούνται σύμφωνα με τις εκάστοτε επιλογές του χρήστη.</p>
        </CookieSection>

        <CookieSection number="3" title="Τρέχουσα λειτουργία">
          <p>Στην τρέχουσα λειτουργία του ιστοτόπου οι προαιρετικές τεχνολογίες αποθήκευσης ή παρακολούθησης παραμένουν ανενεργές μέχρι να αποδεχθείτε τα analytics. Μόνο τότε ενεργοποιείται το Google Analytics 4, για να κατανοούμε ποιες σελίδες χρησιμοποιούνται και να βελτιώνουμε τον ιστότοπο. Για περισσότερες πληροφορίες σχετικά με την επεξεργασία προσωπικών δεδομένων, δείτε την <LegalLink to="/privacy-policy">Πολιτική Απορρήτου</LegalLink>.</p>
          <p>Μετά την αποδοχή, το Google Analytics μπορεί να αποθηκεύει τα cookies <code>_ga</code> και <code>_ga_J5DPZ9874S</code>, με διάρκεια έως 180 ημέρες, για τη διάκριση επισκέψεων και τη μέτρηση χρήσης. Δεν χρησιμοποιούμε αυτά τα δεδομένα για διαφημιστική εξατομίκευση.</p>
          <p>Η επιλογή αποδοχής ή απόρριψης αποθηκεύεται τοπικά στον browser, με το κλειδί <code>crestia_analytics_consent_v1</code>, για έως 180 ημέρες. Αυτή η εγγραφή εξυπηρετεί αποκλειστικά την απομνημόνευση της επιλογής σας και δεν αποστέλλεται στην Google.</p>
        </CookieSection>

        <CookieSection number="4" title="Συγκατάθεση">
          <p>Όπου απαιτείται συγκατάθεση για προαιρετικές τεχνολογίες, αυτές δεν ενεργοποιούνται πριν από την επιλογή του χρήστη.</p>
          <p>Το banner παρέχει τις επιλογές «Αποδοχή» και «Απόρριψη». Αν δεν επιλέξετε ή απορρίψετε, δεν φορτώνεται το Google Analytics και δεν αποστέλλονται μετρήσεις σε αυτό. Οι υπόλοιπες λειτουργίες παραμένουν διαθέσιμες.</p>
          <p>Μπορείτε οποτεδήποτε να αλλάξετε την επιλογή σας από τις «Ρυθμίσεις cookies» στο footer. Η ανάκληση σταματά τη μελλοντική καταγραφή και διαγράφει τα analytics cookies από τον συγκεκριμένο browser. Δεν διαγράφει αναδρομικά δεδομένα που είχαν ήδη αποσταλεί με προηγούμενη συγκατάθεση.</p>
          <p>Αν λήξει ή διαγραφεί η αποθηκευμένη επιλογή, θα ζητηθεί ξανά συγκατάθεση. Αν ο browser εμποδίζει την τοπική αποθήκευση, η επιλογή ισχύει μόνο για την τρέχουσα επίσκεψη.</p>
        </CookieSection>

        <CookieSection number="5" title="Διαχείριση από το πρόγραμμα περιήγησης">
          <p>Οι χρήστες μπορούν επίσης να διαχειρίζονται ή να διαγράφουν cookies μέσω των ρυθμίσεων του προγράμματος περιήγησης που χρησιμοποιούν.</p>
        </CookieSection>

        <CookieSection number="6" title="Αλλαγές στην Πολιτική Cookies">
          <p>Η παρούσα Πολιτική Cookies μπορεί να ενημερώνεται όταν αλλάζουν οι τεχνολογίες που χρησιμοποιεί ο ιστότοπος ή οι σχετικές νομικές απαιτήσεις.</p>
        </CookieSection>

        <CookieSection number="7" title="Επικοινωνία">
          <p>Για ερωτήσεις σχετικά με την παρούσα Πολιτική Cookies, μπορείτε να επικοινωνήσετε με την CRESTIA μέσω της σελίδας <LegalLink to="/contact">Επικοινωνία</LegalLink>.</p>
        </CookieSection>
      </article>
    </div>
  );
}
